import { WizardContext } from "../types/WizardContext";

export const CountGroupBooleans = {
	name: "CountGroupBooleans",
	description:"Counts boolean values in a group",
	parameters: {
		group: {
			type:"string",
			drawer(context:WizardContext){
				return {
					type:"dropdown",
					options:getGroupOptions(context.channels)
				}
			},
			default:null
		}
	},
	output:{
		// name:{
		// 	type:"string",
		// },
		values:{
			type:"number[]",
		},
		labels:{
			type:"string[]",
		}
	}
};

const supportedTypes = [
	"form/checkboxes/option",
];

const getGroupOptions = (channels:any[]) => {
	const supported = channels.filter(c => supportedTypes.findIndex(t => t === c.type) > -1);
	const groups:any[] = [];
	supported.forEach(channel => {

		if(groups.findIndex(g => g.value === channel.group) > -1){
			return;
		}
		groups.push({
			value:channel.group,
			text:channel.groupName
		});
	});
	return groups;
};